import LottiePlayer from './LottiePlayer';
import Typography from './Typography';
import * as S from './styled/NoRecordsFound.styled';

const NoRecordsFound = ({
	lottieName,
	title = 'noRecordsFoundTitle',
	subTitle = 'noRecordsFoundSubtitle',
	actionButton,
	style
}) => (
	<S.Container>
		<S.LottieContainer style={{ maxWidth: '35rem', ...style }}>
			<LottiePlayer name={lottieName ?? 'noResultsFound'} speed={0.7} width="auto" height="auto" />
		</S.LottieContainer>

		<Typography variant="p1" fontWeight="700" align="center" noWrap>
			{title}
		</Typography>

		<Typography align="center" color="var(--content-3)" noWrap>
			{subTitle}
		</Typography>

		{actionButton ? actionButton : undefined}
	</S.Container>
);

export default NoRecordsFound;
